module.exports = __webpack_public_path__ + "img/1300g.1d302220.png";